import createStyleSheet from './create-stylesheet';
const Cssify = {
  create: createStyleSheet
};
export default Cssify;
//# sourceMappingURL=cssify.js.map